import Cookies from 'js-cookie';
// var jwt = require('jsonwebtoken');

export const getJwt = () => {

    return Cookies.get('idealab-jwt');

};